import React from "react";
import { Button, Spin } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import { Booking } from "../../types";

interface BillingHeaderProps {
  booking: Booking | undefined;
  totalAmount: string;
  onCreateInvoice: () => void;
  isCreatingInvoice: boolean;
  selectedServices: string[];
}

export const BillingHeader: React.FC<BillingHeaderProps> = ({
  booking,
  onCreateInvoice,
  isCreatingInvoice,
  selectedServices,
}) => {
  if (!booking) {
    return (
      <Spin size="large" className="flex justify-center items-center h-64" />
    );
  }

  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h2 className="text-2xl font-medium">
          Billing for Booking {booking.bookingReference}
        </h2>
        <p className="text-gray-600">
          Client: {booking.client?.companyName ?? "N/A"} | Created:{" "}
          {new Date(booking.createdAt).toLocaleDateString()}
        </p>
      </div>
      <div className="flex space-x-3">
        <Button
          icon={<DollarOutlined />}
          type="primary"
          onClick={onCreateInvoice}
          disabled={selectedServices.length === 0 || isCreatingInvoice}
          loading={isCreatingInvoice}
        >
          Create Invoice
        </Button>
      </div>
    </div>
  );
};
